import classNames from "classnames";
import { Translation } from "react-i18next";

export function IsFieldValid(formik: any, name: string, innerName: string | undefined = undefined) {
  if (innerName && formik.errors[name] && formik.touched[name]) {
    return !!(formik.touched[name][innerName] && formik.errors[name][innerName]);
  }

  return !!(formik.touched[name] && formik.errors[name]);
}

export function FieldErrorMessage(
  formik: any,
  name: string,
  innerName: string | undefined = undefined
) {
  if (innerName && formik.errors[name]) {
    return IsFieldValid(formik, name, innerName) ? (
      <Translation>
        {t => <small className="p-error h-1rem">{t(formik.errors[name][innerName])}</small>}
      </Translation>
    ) : (
      <small className="h-1rem"></small>
    );
  }
  return IsFieldValid(formik, name) ? (
    <Translation>
      {t => <small className="p-error h-1rem">{t(formik.errors[name])}</small>}
    </Translation>
  ) : (
    <small className="h-1rem"></small>
  );
}

export function FormLabel(formik: any, htmlFor: string, text: string) {
  return (
    <label
      htmlFor={htmlFor}
      className={classNames("block mb-2 text-color font-bold", {
        "p-error": IsFieldValid(formik, htmlFor),
      })}
    >
      {text}
    </label>
  );
}
